import styles from "./Caption.module.scss";

const Caption = ({
  attributionText,
  attributionUrl,
}: {
  attributionText: string;
  attributionUrl: string;
}) => {
  if (!attributionText) return null;
  return (
    <div className={styles.root}>
      {attributionUrl ? (
        <figcaption className={styles.caption}>
          <a
            className={styles.captionLink}
            dangerouslySetInnerHTML={{
              __html: attributionText,
            }}
            href={attributionUrl}
          ></a>
        </figcaption>
      ) : (
        <figcaption
          className={styles.caption}
          dangerouslySetInnerHTML={{
            __html: attributionText,
          }}
        />
      )}
    </div>
  );
};

export default Caption;
